import { useEffect, useState } from 'react';

import { BREAKPOINTS, queryDown } from '@/lib/breakpoints';

/**
 * useIsNarrow — true when the viewport is below `breakpoint` (default: Tailwind `sm`).
 *
 * Blog figures need real layout changes on phones, not just CSS scaling: ECharts
 * lays out axis gutters, label rotation, and font sizes in pixels, so a chart
 * tuned for a 768px column becomes unreadable at ~343px (the usable width inside
 * `max-w-3xl px-4` on a 375px device). Components read this and pass different
 * ECharts options — the mobile-first requirement in RULES_BLOG_POST.
 *
 * SSR-safe: the prerender pass has no `window`, so it starts false (desktop) and
 * corrects on mount.
 */
export const useIsNarrow = (breakpoint = BREAKPOINTS.sm): boolean => {
  const [narrow, setNarrow] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(queryDown(breakpoint));
    const apply = () => setNarrow(mq.matches);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, [breakpoint]);

  return narrow;
};
